import { createAsyncThunk } from '@reduxjs/toolkit';
const BASE_URL = `${process.env.REACT_APP_API_URL}/auth`;

export const loginUserAsync = createAsyncThunk('auth/loginUserAsync', async (credentials, { rejectWithValue, signal }) => {
  try {
    const response = await fetch(`${BASE_URL}/login`, {
      method: 'POST', signal,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(credentials),
    });
    const data = await response.json();
    if (!response.ok) return rejectWithValue(data.error || data.message || 'Authentication failed');
    if (!data.token) return rejectWithValue('Authentication did not return an access token');
    // Persist only when the reducer accepts this request, so logout cannot be undone.
    return data;
  } catch (error) { return rejectWithValue(error.message); }
});

export const checkAuthAsync = createAsyncThunk('auth/checkAuthAsync', async (_, { rejectWithValue, signal }) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) return rejectWithValue('No token found');
    const response = await fetch(`${BASE_URL}/me`, {
      method: 'GET', signal,
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    });
    const data = await response.json();
    if (!response.ok) return rejectWithValue(data.error || data.message || 'Session is invalid or expired');
    if (!data.user?.id) return rejectWithValue('Unable to validate the user profile');
    return data.user;
  } catch (error) { return rejectWithValue(error.message); }
});
